export const getWorkingDaysForNextYear = () => {
  const workingDays = [];
  const today = new Date();
  const oneYearLater = new Date();
  oneYearLater.setFullYear(today.getFullYear() + 1);

  let currentDate = new Date(today);

  while (currentDate < oneYearLater) {
    const day = currentDate.getDay();

    if (day >= 1 && day <= 5) {
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const date = String(currentDate.getDate()).padStart(2, '0');

      workingDays.push(`${year}-${month}-${date}`);
    }

    currentDate.setDate(currentDate.getDate() + 1);
  }

  return workingDays;
};
